import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const TABS: { key: string; label: string; path: string }[] = [
  { key: "triage", label: "Triage", path: "/compliance" },
  { key: "rules", label: "Rules", path: "/compliance/rules" },
  { key: "clinicians", label: "Clinicians", path: "/compliance/clinicians" },
];

const ComplianceTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = (() => {
    if (location.pathname.startsWith("/compliance/clinicians")) return "clinicians";
    if (location.pathname.startsWith("/compliance/rules")) return "rules";
    return "triage";
  })();

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => {
        const tab = TABS.find((t) => t.key === key);
        if (tab) navigate(tab.path);
      }}
      items={TABS.map((t) => ({ key: t.key, label: t.label }))}
    />
  );
};

export default ComplianceTabs;
